// extracted by mini-css-extract-plugin
export default {"desktopApp":"dPC62Vvwm0PCf623gzEz","appName":"vzeM0HeavwlKAwrQWPAx"};